import moment from 'moment';
import { Button } from 'primereact/button';
import Tag from '../../../../components/Display/Tag';
import { getConstant } from '../../../../utils/constants';
import { getImage } from '../../../../utils/imageHelper';
import { Pin } from 'lucide-react';
import styles from "../../cards.module.scss"

function EventItem({ event, handleClickEvent, handleDuplicateEvent, layout }) {
  return (
    <div
      className={`${styles.projectCard} ${layout === "grid" ? styles.projectCardGrid : ''}`}
      onClick={handleClickEvent}>
      <img
        className={styles.projectImage}
        src={event.image ? event.image.file : getImage('img-ph.png')}
        alt={event.image ? event.image.label : 'Non renseignée'}
      />
      <div className={styles.contentContainer}>
        <div className={styles.topInfo}>
          <p className={styles.title}>{event.title}</p>
          <div className="flex flex-row gap-1">
            <span className={styles.subtitle}>
              {moment(event.start_dt).format('ll')}
            </span>
            {'-'}
            <span className={styles.subtitle}>
              {moment(event.end_dt).format('ll')}
            </span>
          </div>
        </div>
        <div className={styles.tagList}>
          <Tag
            tag={{
              label: getConstant('shared.draftTypes', event.is_draft).label,
              bgColor: getConstant('shared.draftTypes', event.is_draft).bgColor
            }}
          />
          <Tag
            tag={{
              label: getConstant('quatrebis.type', event.type).label,
              bgColor: 'bg-sky-950'
            }}
          />
          <Tag
            tag={{
              label: getConstant('quatrebis.place', event.place).label,
              icon: Pin,
              bgColor: 'bg-green-800'
            }}
          />
          <Tag
            tag={{
              label: event.thematique?.label,
              bgColor: 'bg-orange-800'
            }}
          />
        </div>
      </div>
      <Button
        rounded
        icon="pi pi-clone"
        className={styles.button}
        tooltip="Dupliquer l'évènement"
        tooltipOptions={{ position: 'left' }}
        onClick={handleDuplicateEvent}
        severity="secondary"
        outlined
      /></div >

  );
}

export default EventItem;
